import React, {Fragment, useContext} from 'react';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import {Typography} from '@bonprix/design-system';

export default function SearchAlternatives({searchAlternatives, searchQuery}) {
    const {texts} = useContext(articleOverviewStaticContext);

    return (
        <div className="search-alternatives__wrapper">
            <div className="search-alternatives__no-result-text">
                <Typography variant={'h5'} align="center">
                    {texts.searchAlternativesNoResultTextPrefix} "<b>{searchQuery}</b>"{' '}
                    {texts.searchAlternativesNoResultTextSuffix}
                </Typography>
            </div>

            <div className="search-alternatives__alternatives-text">
                <Typography variant={'body1'} align="center">
                    {texts.searchAlternativesAlternativesTextPrefix}
                    {searchAlternatives.alternatives.map((alt, index) => {
                        const separator =
                            index > 0
                                ? index === searchAlternatives.alternatives.length - 1
                                    ? ' ' + texts.searchAlternativesLastAlternativePrefix + ' '
                                    : ', '
                                : ' ';
                        return (
                            <Fragment key={index}>
                                {separator}"{alt.searchTerm}"
                                {index === searchAlternatives.alternatives.length - 1 ? ' ' : ''}
                            </Fragment>
                        );
                    })}
                    {texts.searchAlternativesAlternativesTextSuffix}
                </Typography>
            </div>
        </div>
    );
}
